module.exports = __webpack_public_path__ + "media/icons/ic_close_loan-db13d313.svg";